import React from 'react';
import { Menu } from '@teetsh/app/src/components/Menu';
import { TagPlan } from '@teetsh/app/src/containers/Header/components/TagPlan';
import { Trans } from 'react-i18next';
import 'twin.macro';
import { UserAccount } from '@teetsh/app/src/types/user';

interface Props {
  userAccount: UserAccount;
}

export function PlanInfoMenuItem({ userAccount }: Props) {
  return (
    <Menu.Item disabled>
      <div tw="flex items-center py-3 px-4 bg-neutral-white rounded-t-lg">
        <div tw="font-semibold">
          <Trans
            i18nKey="common:userProfileMenu.title"
            values={{ planLabel: userAccount.currentPlanLabel }}
          >
            Abonnement
            <TagPlan userAccount={userAccount} />
          </Trans>
        </div>
      </div>
    </Menu.Item>
  );
}
